import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { func, string } from 'prop-types'
import { toastr } from 'react-redux-toastr'

// Actions
import { updateActiveAccount } from '../actions'

// Components
import CampaignAddForm from './CampaignAddForm'

// Utils
import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

class CampaignAdd extends Component {
  constructor () {
    super()

    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit (formValues) {
    let url = `${config.url}/campaigns/add_with_video`
    axios({
      method: 'post',
      url: url,
      headers: {'X-User-Token': getAuthToken()},
      data: {
        campaign_name: formValues.campaign_name,
        video_name: formValues.video_name,
        account_id: this.props.activeAccountId
      }
    })
      .then((res) => {
        this.props.updateActiveAccount(res.data)
        toastr.success('Campanha criada com sucesso!')
        this.props.changeUrl('/campaigns')
      })
      .catch((err) => {
        toastr.error('Ocorreu um erro ao criar a campanha. Tente novamente.')
      })
  }
  render () {
    return (
      <CampaignAddForm onSubmit={this.handleSubmit} />
    )
  }
}

CampaignAdd.propTypes = {
  updateActiveAccount: func,
  changeUrl: func,
  activeAccountId: string
}

const mapStateToProps = (state) => ({
  activeAccountId: state.app.activeAccount._id
})

const mapDispatchToProps = (dispatch) => ({
  updateActiveAccount: (campaign) => {
    dispatch(updateActiveAccount(campaign))
  },
  changeUrl: (url) => {
    dispatch(push(url))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CampaignAdd)



// WEBPACK FOOTER //
// ./src/components/CampaignAdd.js